import addError from '../../../utils/error.jsx';
import { update } from './update';

export function request(id) {
    return {
        type: 'USER_CANCEL_WITHDRAWAL_REQUEST',
        id
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'USER_CANCEL_WITHDRAWAL_ERROR',
        errors
    };
}

export function finish({ user, transaction }) {
    return (dispatch) => {
        dispatch(update(user));

        dispatch({
            type: 'USER_CANCEL_WITHDRAWAL_FINISH',
            data: transaction
        });
    };
}

export function clear() {
    return {
        type: 'USER_CANCEL_WITHDRAWAL_CLEAR'
    };
}
